import { createContext,useEffect,useReducer } from "react";

export const StaffAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'STAFF_LOGIN':
        return {staff: action.payload}

        case 'STAFF_LOGOUT':
            return {
                staff:null,
            }

        default:
            return state;    
    }
}

export const StaffAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        staff:null
    });

    useEffect(()=>{
        const staff = JSON.parse(localStorage.getItem('staff'));
        if(staff){
            dispatch({type:'STAFF_LOGIN', payload:staff});
        }

    },[]);

    console.log('StaffAuthContext State ', state);

    return (
        <StaffAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </StaffAuthContext.Provider>
    )
}